import { Card, CardContent } from "@/components/ui/card";
const JourneyTab = () => {
  return <Card className="border-2 border-black">
      <CardContent className="pt-6">
        <div className="space-y-6">
          <p className="text-gray-700 leading-relaxed font-bold text-xl">This is not just a new platform - it's the world's first AI-enabled knowledge network and marketplace for the wisdom of the workforce.</p>
          
          <div className="text-lg text-gray-700 leading-relaxed">
            <p className="mb-4 text-lg">Together we will prove that human insight paired with agentic AI, using structured attribution and incentive models, can:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Preserve institutional wisdom before it departs</li>
              <li>Enable more contextualized enterprise AI</li>
              <li>Attribute the workforce before automation</li>
              <li>Protect intellectual property in a multi-stakeholder environment</li>
            </ul>
          </div>
          
          <p className="text-lg text-gray-700 leading-relaxed">
            iSPAI converts the wisdom of the workforce into an activated asset, trusted, owned and maintained, and retained for use by the enterprise.
          </p>
        </div>
      </CardContent>
    </Card>;
};
export default JourneyTab;